import { render, staticRenderFns } from "./Squawks.vue?vue&type=template&id=d09b0bae&scoped=true"
import script from "./Squawks.vue?vue&type=script&lang=js"
export * from "./Squawks.vue?vue&type=script&lang=js"
import style0 from "./Squawks.vue?vue&type=style&index=0&id=d09b0bae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d09b0bae",
  null
  
)

export default component.exports